import React from 'react'

const PhoneNumberHubContext = React.createContext({})

export default PhoneNumberHubContext
